module.exports = __webpack_public_path__ + "prod/1.42.2/img/input-icon-name.a3563542.svg";